<div class="w-full max-w-md mx-auto space-y-6 animate-in fade-in duration-300 p-1">
  <!-- Header -->
  <div class="text-center space-y-3">
    <div
      class="w-16 h-16 mx-auto rounded-2xl flex items-center justify-center mb-4"
      [style.backgroundColor]="themeColor + '15'"
    >
      <lucide-icon
        [img]="icons.Loader2"
        class="w-8 h-8 animate-spin"
        [style.color]="themeColor"
      ></lucide-icon>
    </div>
    <h2 class="text-2xl font-bold text-slate-900">{{ title }}</h2>
    <p class="text-slate-500">{{ subtitle }}</p>
  </div>

  <!-- Progress Card -->
  <div class="bg-slate-50 p-6 rounded-2xl border border-slate-100 space-y-6">
    <!-- Progress Bar -->
    @let progress = (progress$ | async) ?? 0;
    <div class="space-y-2">
      <div class="flex justify-between items-center text-sm">
        <span class="font-medium text-slate-600">Progress</span>
        <span class="font-bold" [style.color]="themeColor">
          {{ progress | number: '1.0-0' }}%
        </span>
      </div>
      <div class="w-full h-2 bg-slate-200 rounded-full overflow-hidden">
        <div
          class="h-full rounded-full transition-[width] duration-100 ease-linear"
          [style.backgroundColor]="themeColor"
          [style.width.%]="progress"
        ></div>
      </div>
    </div>

    <!-- Loading Steps -->
    @let currentIdx = (currentStepIndex$ | async) ?? 0;
    <div class="space-y-2">
      @for (step of steps; track step.id; let i = $index) {
        <div
          class="flex items-center gap-3 p-3 rounded-xl transition-all duration-300"
          [class.bg-white]="i === currentIdx"
          [class.shadow-sm]="i === currentIdx"
          [class.opacity-50]="i > currentIdx"
        >
          <!-- Step indicator -->
          <div
            class="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300"
            [class.text-white]="i <= currentIdx"
            [style.backgroundColor]="
              i < currentIdx
                ? '#22c55e'
                : i === currentIdx
                  ? themeColor
                  : '#e2e8f0'
            "
          >
            @if (i < currentIdx) {
              <lucide-icon [img]="icons.Check" class="w-4 h-4"></lucide-icon>
            } @else if (i === currentIdx) {
              <lucide-icon
                [img]="icons.Loader2"
                class="w-4 h-4 animate-spin"
              ></lucide-icon>
            } @else {
              <span class="text-xs font-bold text-slate-400">{{ step.id }}</span>
            }
          </div>

          <!-- Step label -->
          <span
            class="text-sm font-medium transition-colors duration-300"
            [class.text-slate-400]="i < currentIdx"
            [class.text-slate-800]="i === currentIdx"
            [class.text-slate-400]="i > currentIdx"
          >
            {{ step.label }}
          </span>
        </div>
      }
    </div>
  </div>

  <!-- Subtle tip -->
  <p class="text-center text-sm text-slate-400">{{ tipText }}</p>
</div>
